define("ember-cli-flash/utils/computed", ["exports", "@ember/object", "@ember/object/internals", "@ember/utils"], function (_exports, _object, _internals, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.guidFor = guidFor;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/object/internals",0,"@ember/utils"eaimeta@70e063a35619d71f

  function guidFor(dependentKey) {
    return (0, _object.computed)(dependentKey, {
      get() {
        const value = (0, _object.get)(this, dependentKey); // it's possible that a value has no toString as some objects don't implement the guid field
        // this early return it to avoid errors being thrown when calling undefined.toString()

        if ((0, _utils.isNone)(value)) return;
        return (0, _internals.guidFor)(value.toString());
      }

    });
  }
});